import React from 'react';
import { connect } from 'react-redux';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const mapStateToProps = ({
  dialog: {
    contentProps: {
      removedMetiers = [],
    } = {}
  },
}) => ({
  removedMetiers,
});

const ConfirmationSousMetiersDialog = ({
  removedMetiers,
}) => (
  <Grid container spacing={2}>
    {removedMetiers.length > 0 && (
      <Grid item xs={12}>
        <Typography variant="subtitle2" color="error">
          Métiers supprimés :
        </Typography>
        <List dense>
          {removedMetiers.map((metier) => (
            <ListItem key={`removed-${metier.id}`}>
              <ListItemIcon>
                <RemoveCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary={metier.name} />
            </ListItem>
          ))}
        </List>
      </Grid>
    )}
  </Grid>
);

export default connect(
  mapStateToProps,
)(ConfirmationSousMetiersDialog);
